//replaces keyword-analysis-total-visits.html

import { KeywordAnalysisTotalVisits } from "app/components/React/KeywordAnalysisTotalVisits/KeywordAnalysisTotalVisits";
import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import type { FC } from "react";

export const keywordAnalysisTotalVisitsV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;

    return (
        <KeywordAnalysisTotalVisits
            trafficTrend={widget.data}
            dashboardView={false}
            maxMonths={widget.maxMonths}
        />
    );
};
